<template>
    <th :class="[`table-header-${field}`, { 'vertical': this.isVertical, 'centred': this.isCentred, 'd-none': !this.isVisible }]"
        v-on:click="sortBy(field)">

        <span class="inner">
            <span v-if="label" class="label">{{ label + (units ? ` (${units})` : '') }}</span>

            <i
                @click.stop="toggleTooltip"
                @mouseover="showTooltip"
                @mouseleave="hideTooltip"
                v-if="hasTooltip"
                class="fa fa-info-circle fa-stack-1x">
            </i>

            <span v-if="sort" class="fa-stack sort-stack fa-1x">
                <i :class="showIcon(field, 'asc')" class="fa fa-sort-up fa-stack-1x"></i>
                <i :class="showIcon(field, 'desc')" class="fa fa-sort-down fa-stack-1x"></i>
            </span>
        </span>

        <div v-if="isOpen" class="tree-carbon-tooltip" @click.stop>
            <p>{{tooltipText}}</p>
        </div>
    </th>
</template>

<script>
export default {
    name: 'DataTableHeader',
    props: {
        label: String,
        field: String,
        sort: Object,
        isVisible: {
            type: Boolean,
            default: true
        },
        isVertical: {
            type: Boolean,
            default: false
        },
        isCentred: {
            type: Boolean,
            default: false
        },
        hasTooltip: {
            type: Boolean,
            default: false
        },
        tooltipText: {
            type: String,
            required: false
        },
        units: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            isOpen: false,
            isClicked: false
        };
    },

    methods: {
        showIcon(column, direction) {
            return (column === this.sort.by && direction === this.sort.direction) ? 'active' : ''
        },

        sortBy(column) {
            if(this.sort && this.sort.hasOwnProperty('by') && this.sort.hasOwnProperty('direction')) {

                if (column === this.sort.by) {
                    this.sort.direction = (this.sort.direction === 'desc') ? 'asc' : 'desc'
                }

                this.sort.by = column
                this.$emit('update:sort', this.sort)
            }
        },

        showTooltip() {
            if (!this.isClicked) {
                this.isOpen = true;
            }
        },

        hideTooltip() {
            if (!this.isClicked) {
                this.isOpen = false;
            }
        },

        toggleTooltip() {
            this.isClicked = !this.isClicked;
            this.isOpen = this.isClicked;
        },

        handleClickOutside(event) {
            if (this.isClicked && !this.$el.contains(event.target)) {
                this.isOpen = false;
                this.isClicked = false;
            }
        }
    },

    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    }
}
</script>
